import React from 'react';

export default function({children, white, center}){
    
    return <h1 className={`mb-5 text-4xl md:text-6xl lg:text-8xl font-bold md:leading-[1.1] tracking-[-0.05em] ${ white ? `text-white` : `text-dark-purple` } ${ center ? `text-center` : `` }`}>{children}</h1>;

}